import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet, NgxUiLoaderModule],
})
export class AppComponent {
  title: string;

  constructor() {
    this.title = 'Classificatore';
  }
}
